import { Link } from "react-router-dom";
import { Logo } from "@/components/layout/Header";
import { useCatalog } from "@/lib/useCatalog";

export const Footer = () => {
  const { groups } = useCatalog();
  return (
    <footer className="mt-24 border-t border-stone-200 bg-white" data-testid="site-footer">
      <div className="container-page grid gap-12 py-16 md:grid-cols-[1.4fr_repeat(3,1fr)]">
        <div className="max-w-xs space-y-4">
          <Logo />
          <p className="text-sm leading-relaxed text-stone-500">
            Tuntas menghubungkan Anda dengan penyedia jasa tepercaya di seluruh Indonesia. Bandingkan penawaran, pilih yang paling cocok.
          </p>
        </div>
        {groups.slice(0, 3).map((g) => (
          <div key={g.slug} className="space-y-3">
            <h4 className="text-sm font-semibold text-stone-900">{g.name}</h4>
            <ul className="space-y-2">
              {g.subcategories.slice(0, 5).map((s) => (
                <li key={s.slug}>
                  <Link to={`/kategori/${s.slug}`} className="text-sm text-stone-500 hover:text-teal-800" data-testid={`footer-link-${s.slug}`}>
                    {s.name}
                  </Link>
                </li>
              ))}
            </ul>
          </div>
        ))}
      </div>
      <div className="border-t border-stone-100">
        <div className="container-page flex flex-col gap-2 py-6 text-xs text-stone-400 sm:flex-row sm:justify-between">
          <span>© {new Date().getFullYear()} Tuntas. Semua hak dilindungi.</span>
          <span>Dibuat untuk Indonesia · Bahasa Indonesia</span>
        </div>
      </div>
    </footer>
  );
};
